import styled from 'styled-components';
export const ProfileOuterContainer = styled.div`
  background-color: transparent;
  min-height: 100dvh;
`;

// ─────────────────────────────────────────────
// MOBILE LAYOUT (unchanged)
// ─────────────────────────────────────────────

export const HomeContainer = styled.div`
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 10px 0;
  color: ${p => p.theme.colors.text.primary};

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const HomeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const GreetingText = styled.div`
  h1 { font-size: 32px; font-weight: 800; margin: 0; color: ${p => p.theme.colors.text.primary}; line-height: 1.2; }
  p { font-size: 16px; color: ${p => p.theme.colors.text.secondary}; margin: 4px 0 0; }
`;

export const BalanceCard = styled.div`
  background: ${p => p.theme.isDark
    ? 'linear-gradient(135deg, rgba(31, 41, 55, 0.9), rgba(17, 24, 39, 0.95))'
    : 'linear-gradient(135deg, #1f2937, #111827)'};
  color: #ffffff;
  padding: 24px;
  border-radius: 20px;
  text-align: center;
  margin-bottom: 24px;
  box-shadow: ${p => p.theme.isDark
    ? '0 10px 30px rgba(0, 0, 0, 0.5), inset 0 1px 1px rgba(255, 255, 255, 0.1)'
    : '0 12px 24px rgba(31, 41, 55, 0.25)'};
  position: relative;
  overflow: hidden;
  border: 1px solid ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.05)' : 'transparent'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 100%);
    pointer-events: none;
  }
`;

export const BalanceLabel = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 8px;
  position: relative;
  z-index: 1;
`;

export const TotalBalance = styled.h2`
  font-size: 38px;
  font-weight: 800;
  letter-spacing: -1.5px;
  margin: 0;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
`;

export const AccountInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  position: relative;
  z-index: 1;
`;

export const AccountInfoItem = styled.div`
  text-align: left;
  span {
    font-size: 11px;
    text-transform: uppercase;
    opacity: 0.7;
    letter-spacing: 0.5px;
  }
  p {
    margin: 4px 0 0;
    font-size: 14px;
    font-weight: 600;
    font-family: monospace;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 20px 0 10px;
  color: ${p => p.theme.colors.text.primary};
`;

export const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SummaryItem = styled.button`
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: ${p => p.theme.colors.background.paper};
  padding: 15px;
  border-radius: 12px;
  text-decoration: none;
  color: ${p => p.theme.colors.text.primary};
  border: none;
  width: 100%;
  text-align: left;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;

  &:hover {
    background-color: ${p => p.theme.colors.background.main};
    transform: translateY(-2px);
  }
`;

export const ActionIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: ${p => p.theme.colors.background.selected};
`;

export const ItemInfo = styled.div`
  flex-grow: 1;
  overflow: hidden;
  p { margin: 0; }
`;

export const ItemName = styled.p`
  font-weight: 600;
`;

export const ItemDetail = styled.p`
  font-size: 13px;
  color: ${p => p.theme.colors.text.secondary};
  font-family: monospace;
`;

export const ItemBalance = styled.p`
  font-weight: 600;
  font-size: 16px;
`;

export const TxListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 10px;
`;

export const TxRowMob = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: none;
  text-align: left;
  padding: 12px 15px;
  background: ${p => p.theme.colors.background.paper};
  border-radius: 12px;
  margin-bottom: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  cursor: pointer;
`;

export const TxInfoMob = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TxDescMob = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${p => p.theme.colors.text.primary};
`;

export const TxDateMob = styled.span`
  font-size: 12px;
  color: ${p => p.theme.colors.text.disabled};
`;

export const TxAmountMob = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${p => p.$isDebit ? p.theme.colors.danger.main : p.theme.colors.secondary.main};
`;

export const ViewMoreBtn = styled.button`
  width: 100%;
  padding: 12px;
  background: ${p => p.theme.colors.background.paper};
  border: 1px solid ${p => p.theme.colors.border.main};
  border-radius: 12px;
  color: ${p => p.theme.colors.primary.light};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 5px;
  transition: background 0.2s;
  &:hover { background: ${p => p.theme.colors.background.main}; }
`;

export const ReceiveMoneyBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  background: ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)'};
  border: 1px solid ${p => p.theme.colors.border.main};
  border-radius: 8px;
  color: ${p => p.theme.colors.text.primary};
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 8px;
  &:hover {
    background: ${p => p.theme.colors.background.selected};
    border-color: ${p => p.theme.colors.border.hover};
  }
`;

export const ReceiveMoneyMobileBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 14px;
  transition: all 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }
`;

export const DesktopDashboard = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 28px;
    padding: 32px 32px 40px 32px;
    box-sizing: border-box;
    align-content: start;
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
  }
`;

export const MobileOnly = styled.div`
  display: block;
  @media (min-width: 1024px) {
    display: none;
  }
`;

// ── DESKTOP HEADER & GREETING ─────────────────

export const DesktopHeader = styled.div`
  grid-column: 1 / -1;
  margin-bottom: 12px;
  padding-left: 4px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const DesktopGreeting = styled.div`
  h1 { 
    font-size: 32px; 
    font-weight: 800; 
    color: ${p => p.theme.colors.text.primary}; 
    margin: 0; 
    line-height: 1.2;
    letter-spacing: -0.5px;
  }
  p { 
    font-size: 15px; 
    color: ${p => p.theme.colors.text.secondary}; 
    margin: 6px 0 0; 
    letter-spacing: 0.2px;
  }
`;

export const ConsolidatedBalance = styled.div`
  text-align: right;
  
  @media (max-width: 768px) {
    text-align: left;
  }
  
  .label {
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.45)'};
    letter-spacing: 1.5px;
    margin-bottom: 4px;
    display: block;
  }
  
  .value {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: -0.5px;
    color: ${p => p.theme.colors.text.primary};
  }
`;

// ── DESKTOP COLUMNS ───────────────────────────

export const SelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  
  .selector-label {
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)'};
    letter-spacing: 1.5px;
  }
  
  .selector-instruction {
    font-size: 10px;
    font-weight: 400;
    color: ${p => p.theme.colors.text.disabled};
    opacity: 0.85;
  }
`;

export const DesktopMainColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const DesktopSidebarColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

// ── ACCOUNT SELECTOR PILLS ─────────────────────

export const AccountPillRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: -14px;
`;

export const AccountPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  
  border: 1px solid ${p => p.$active 
    ? (p.theme.isDark ? '#ffffff' : '#111827') 
    : (p.theme.isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')};
    
  background: ${p => p.$active 
    ? (p.theme.isDark ? '#ffffff' : '#111827') 
    : 'transparent'};
    
  color: ${p => p.$active 
    ? (p.theme.isDark ? '#111827' : '#ffffff') 
    : (p.theme.isDark ? 'rgba(255, 255, 255, 0.65)' : '#374151')};

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${p => p.$active ? '#10b981' : 'transparent'};
    border: 1px solid ${p => p.$active ? '#10b981' : (p.theme.isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)')};
    transition: all 0.2s ease;
  }

  &:hover {
    border-color: ${p => p.theme.isDark ? '#ffffff' : '#111827'};
    background: ${p => p.$active 
      ? (p.theme.isDark ? '#ffffff' : '#111827') 
      : (p.theme.isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)')};
    color: ${p => p.$active 
      ? (p.theme.isDark ? '#111827' : '#ffffff') 
      : (p.theme.isDark ? '#ffffff' : '#111827')};
  }
`;

// ── HERO USD CARD ──────────────────────────────

export const HeroUSDCard = styled.div`
  background: #111827;
  color: #ffffff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  overflow: hidden;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }
`;

export const HeroUSDLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const HeroUSDRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const HeroTitle = styled.p`
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin: 0 0 8px;
`;

export const HeroAmount = styled.h2`
  font-size: 46px;
  font-weight: 800;
  letter-spacing: -2px;
  color: #ffffff;
  margin: 0 0 24px;
`;

export const HeroAccountDetails = styled.div`
  display: flex;
  gap: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .label {
    font-size: 9px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.4);
    letter-spacing: 1px;
    font-weight: 600;
  }

  .value {
    font-size: 13px;
    font-weight: 500;
    font-family: 'Inter', monospace;
    color: rgba(255, 255, 255, 0.9);
  }

  .status-active {
    color: #10b981;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const HeroInstructionsBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 22px;
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 8px;
  color: #111827;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  letter-spacing: 0.2px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  }
`;

export const InstructionsHelpText = styled.p`
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 8px;
  line-height: 1.4;
  opacity: 0.85;
  text-align: right;
  letter-spacing: 0.2px;
  
  @media (max-width: 1200px) {
    text-align: left;
  }
`;

// ── TRANSACTIONS CARD ─────────────────────────

export const TransactionsCard = styled.div`
  background: ${p => p.theme.colors.background.paper};
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.01);
  border: 1px solid ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.08)' : '#e5e7eb'};
  
  @media (min-width: 1024px) {
    grid-column: 1 / -1;
  }
`;

// ── SIDEBAR PANEL CARD ─────────────────────────

export const SidebarPanelCard = styled.div`
  background: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  border: none;
`;

// ── ACCOUNT LIST ITEMS ────────────────────────

export const PanelTitle = styled.h3`
  font-size: 11px;
  font-weight: 600;
  color: ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.45)'};
  margin: 0 0 16px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`;

export const AccountListItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  border: none;
  text-align: left;
  padding: 10px 12px;
  background: ${p => p.$active 
    ? (p.theme.isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)') 
    : p.theme.colors.background.main};
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid ${p => p.$active ? (p.theme.isDark ? '#ffffff' : '#111827') : 'transparent'};
  padding-left: ${p => p.$active ? '9px' : '12px'};

  &:last-child { margin-bottom: 0; }

  &:hover {
    background: ${p => p.theme.colors.background.selected};
    transform: translateX(2px);
    ${p => !p.$active && `border-left-color: ${p.theme.isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.15)'};`}
  }
`;

export const AccountItemIcon = styled.div`
  width: 34px;
  height: 34px;
  background: ${p => p.theme.colors.border.main};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${p => p.theme.isDark ? 'rgba(255,255,255,0.8)' : '#111827'};
`;

export const AccountItemInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AccountItemName = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: ${p => p.theme.colors.text.primary};
  margin: 0;
`;

export const AccountItemSub = styled.p`
  font-size: 11px;
  color: ${p => p.theme.colors.text.disabled};
  margin: 2px 0 0;
  font-family: monospace;
`;

export const AccountItemBalance = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${p => p.theme.colors.text.primary};
  white-space: nowrap;
`;

// ── TRANSACTION TABLE ─────────────────────────

export const TxTable = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const TxTableHead = styled.div`
  display: grid;
  grid-template-columns: 40px 80px 1fr 90px 110px 100px;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.08)' : '#e5e7eb'};
`;

export const TxTableHeadCell = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: ${p => p.theme.colors.text.disabled};
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const TxIconCircle = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.$isDebit 
    ? (p.theme.isDark ? 'rgba(239, 68, 68, 0.12)' : 'rgba(239, 68, 68, 0.06)') 
    : (p.theme.isDark ? 'rgba(16, 185, 129, 0.12)' : 'rgba(16, 185, 129, 0.06)')};
  color: ${p => p.$isDebit 
    ? (p.theme.isDark ? '#f87171' : '#dc2626') 
    : (p.theme.isDark ? '#34d399' : '#059669')};
`;

export const TxTableRow = styled.div`
  display: grid;
  grid-template-columns: 40px 80px 1fr 90px 110px 100px;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.04)' : '#f3f4f6'};
  align-items: center;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;

  &:last-child { border-bottom: none; }

  &:hover { 
    background: ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.01)'}; 
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.015);
    border-bottom-color: transparent;
  }
`;

export const TxCell = styled.span`
  font-size: 13px;
  color: ${p => p.color || p.theme.colors.primary.light};
  font-weight: ${p => p.bold ? '600' : '400'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TxBadge = styled.span`
  font-size: 11px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: ${p => p.green 
    ? (p.theme.isDark ? 'rgba(16, 185, 129, 0.1)' : 'rgba(16, 185, 129, 0.06)') 
    : p.yellow 
      ? (p.theme.isDark ? 'rgba(245, 158, 11, 0.1)' : 'rgba(245, 158, 11, 0.06)') 
      : (p.theme.isDark ? 'rgba(107, 114, 128, 0.1)' : 'rgba(107, 114, 128, 0.06)')};
      
  color: ${p => p.green 
    ? (p.theme.isDark ? '#34d399' : '#059669') 
    : p.yellow 
      ? (p.theme.isDark ? '#fbbf24' : '#d97706') 
      : (p.theme.isDark ? '#9ca3af' : '#6b7280')};

  &::before {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: currentColor;
  }
`;

export const DesktopViewMoreBtn = styled.button`
  width: 100%;
  padding: 10px;
  background: transparent;
  border: 1px solid ${p => p.theme.colors.border.main};
  border-radius: 8px;
  color: ${p => p.theme.colors.primary.light};
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 5px;
  transition: all 0.2s ease;
  &:hover { 
    background: ${p => p.theme.colors.background.main};
    border-color: ${p => p.theme.colors.border.hover};
  }
`;

// ── DESKTOP QUICK ACTIONS ─────────────────────

export const DesktopQAGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const QACard = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.04)' : '#f3f4f6'};
  padding: 16px 8px;
  cursor: pointer;
  text-align: left;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  &:last-child { border-bottom: none; }

  &:hover {
    background: ${p => p.theme.isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)'};
    padding-left: 12px;
    
    div.qa-icon-circle {
      background: ${p => p.theme.isDark ? '#ffffff' : '#111827'};
      color: ${p => p.theme.isDark ? '#111827' : '#ffffff'};
    }
    
    span.qa-arrow {
      transform: translateX(4px);
      opacity: 1;
    }
  }
`;

export const QAIconCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${p => p.theme.isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)'};
  color: ${p => p.theme.colors.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
`;

export const QAText = styled.div`
  flex: 1;
  min-width: 0;
  margin-left: 14px;
`;

export const QALabel = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: ${p => p.theme.colors.text.primary};
  margin: 0;
  letter-spacing: 0.1px;
`;

export const QASub = styled.p`
  font-size: 11px;
  color: ${p => p.theme.colors.text.disabled};
  margin: 2px 0 0;
`;

export const QAArrow = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${p => p.theme.colors.text.disabled};
  transition: all 0.2s ease;
  opacity: 0.5;
  margin-left: 10px;
`;

// ─────────────────────────────────────────────
// MY ACCOUNT – Tab panel styled components
// ─────────────────────────────────────────────

export const MyAccountPanel = styled.div`
  background: ${p => p.theme.colors.background.paper};
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const MyAccountHeader = styled.div`
  padding: 18px 22px 0;
  border-bottom: 1px solid ${p => p.theme.colors.background.selected};
`;

export const MyAccountTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${p => p.theme.colors.text.primary};
  margin: 0 0 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TabRow = styled.div`
  display: flex;
  gap: 0;
  overflow-x: auto;
  &::-webkit-scrollbar { display: none; }
`;

export const TabBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px 10px;
  font-size: 13px;
  font-weight: ${p => p.$active ? '700' : '500'};
  color: ${p => p.$active ? p.theme.colors.text.primary : p.theme.colors.text.disabled};
  background: none;
  border: none;
  border-bottom: 2px solid ${p => p.$active ? p.theme.colors.text.primary : 'transparent'};
  cursor: pointer;
  transition: color 0.18s, border-color 0.18s;
  white-space: nowrap;

  &:hover { color: ${p => p.theme.colors.primary.light}; }
`;

export const TabContent = styled.div`
  padding: 20px 22px;
`;

/* -- Transaction history tab -- */

export const TxToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 12px;
  flex-wrap: wrap;
`;

export const TxSearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  background: ${p => p.theme.colors.background.main};
  border: 1px solid ${p => p.theme.colors.background.selected};
  border-radius: 9px;
  padding: 6px 11px;
  flex: 1;
  max-width: 260px;

  input {
    border: none;
    background: none;
    outline: none;
    font-size: 13px;
    color: ${p => p.theme.colors.text.primary};
    width: 100%;
    &::placeholder { color: ${p => p.theme.colors.text.disabled}; }
  }
`;

export const ExportGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

export const ExportLabel2 = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${p => p.theme.colors.text.disabled};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ExportBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 13px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  border: 1.5px solid ${p => p.$csv ? '#10b981' : '#6366f1'};
  background: ${p => p.$csv ? 'rgba(16,185,129,0.06)' : 'rgba(99,102,241,0.06)'};
  color: ${p => p.$csv ? p.theme.colors.secondary.main : '#4f46e5'};

  &:hover {
    background: ${p => p.$csv ? 'rgba(16,185,129,0.14)' : 'rgba(99,102,241,0.14)'};
  }
`;

export const FilterChipRow = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

export const FilterChip = styled.button`
  padding: 4px 11px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  border: 1px solid ${p => p.$active ? p.theme.colors.text.primary : p.theme.colors.border.main};
  background: ${p => p.$active ? p.theme.colors.text.primary : p.theme.colors.background.main};
  color: ${p => p.$active ? p.theme.colors.background.paper : p.theme.colors.text.secondary};
`;

export const TxRow2 = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr 70px 110px 80px 32px;
  gap: 8px;
  padding: 9px 10px;
  border-bottom: 1px solid ${p => p.theme.colors.background.main};
  align-items: center;
  transition: background 0.15s;
  border-radius: 7px;

  &:hover { background: ${p => p.theme.colors.background.main}; }
  &:last-child { border-bottom: none; }
`;

export const TxHead2 = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr 70px 110px 80px 32px;
  gap: 8px;
  padding: 7px 10px;
  background: ${p => p.theme.colors.background.main};
  border-radius: 8px;
  margin-bottom: 4px;
`;

export const TxHeadCell2 = styled.span`
  font-size: 10.5px;
  font-weight: 700;
  color: ${p => p.theme.colors.text.disabled};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TxIconBtn = styled.button`
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: ${p => p.theme.colors.text.disabled};
  transition: background 0.15s;
  &:hover { background: ${p => p.theme.colors.background.selected}; color: ${p => p.theme.colors.primary.light}; }
`;

/* -- Wallet Permissions tab -- */

export const WpHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 12px;
`;

export const WpTitleBlock = styled.div``;
export const WpTitle = styled.p`
  font-size: 13.5px;
  font-weight: 700;
  color: ${p => p.theme.colors.text.primary};
  margin: 0;
`;
export const WpSub = styled.p`
  font-size: 11.5px;
  color: ${p => p.theme.colors.text.disabled};
  margin: 3px 0 0;
`;

export const InviteBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  border-radius: 9px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  background: ${p => p.theme.colors.text.primary};
  color: ${p => p.theme.colors.background.paper};
  border: none;
  white-space: nowrap;
  transition: opacity 0.18s;
  &:hover { opacity: 0.85; }
`;

export const RolesTable = styled.div`
  border-radius: 12px;
  border: 1px solid ${p => p.theme.colors.background.selected};
  overflow: hidden;
`;

export const RolesHead = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px 150px 80px 80px;
  gap: 8px;
  padding: 9px 14px;
  background: ${p => p.theme.colors.background.main};
  border-bottom: 1px solid ${p => p.theme.colors.background.selected};
`;

export const RolesHeadCell = styled.span`
  font-size: 10.5px;
  font-weight: 700;
  color: ${p => p.theme.colors.text.disabled};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const RolesRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px 150px 80px 80px;
  gap: 8px;
  padding: 11px 14px;
  border-bottom: 1px solid ${p => p.theme.colors.background.main};
  align-items: center;
  transition: background 0.15s;
  &:last-child { border-bottom: none; }
  &:hover { background: ${p => p.theme.colors.background.main}; }
`;

export const UserCellWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const UserAvatarSmall = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: ${p => p.$bg};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: ${p => p.theme.colors.background.paper};
  flex-shrink: 0;
`;

export const UserNameCell = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: ${p => p.theme.colors.text.primary};
  margin: 0;
`;

export const UserEmailCell = styled.p`
  font-size: 11px;
  color: ${p => p.theme.colors.text.disabled};
  margin: 2px 0 0;
`;

export const RolePill = styled.span`
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
  background: ${p =>
    p.$role === 'Admin' ? 'rgba(31,41,55,0.1)' :
      p.$role === 'Manager' ? 'rgba(245,158,11,0.12)' :
        'rgba(16,185,129,0.12)'};
  color: ${p =>
    p.$role === 'Admin' ? p.theme.colors.text.primary :
      p.$role === 'Manager' ? '#d97706' :
        p.theme.colors.secondary.main};
`;

export const PermTagsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const PermTag = styled.span`
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  background: ${p => p.theme.colors.background.selected};
  border-radius: 5px;
  color: ${p => p.theme.colors.primary.light};
`;

export const StatusMark = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: ${p => p.$active ? p.theme.colors.secondary.main : p.theme.colors.text.disabled};
  &::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${p => p.$active ? p.theme.colors.secondary.main : p.theme.colors.text.disabled};
  }
`;

export const RowActions = styled.div`
  display: flex;
  gap: 3px;
`;

export const RowIconBtn = styled.button`
  width: 26px;
  height: 26px;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.colors.text.disabled};
  transition: background 0.15s, color 0.15s;
  &:hover { background: ${p => p.theme.colors.background.selected}; color: ${p => p.theme.colors.primary.light}; }
`;

export const InfoBanner2 = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 14px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  margin-bottom: 14px;
`;

export const InfoBanner2Text = styled.p`
  font-size: 12px;
  color: #166534;
  margin: 0;
  font-weight: 500;
`;

/* -- Statements tab -- */

export const StmtRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const StmtSelect = styled.select`
  padding: 9px 14px;
  border-radius: 10px;
  border: 1.5px solid ${p => p.theme.colors.border.main};
  background: ${p => p.theme.colors.background.main};
  font-size: 13px;
  font-weight: 600;
  color: ${p => p.theme.colors.text.primary};
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
  &:focus { border-color: ${p => p.theme.colors.text.primary}; }
`;

export const StmtDownloadBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 20px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  background: ${p => p.theme.colors.text.primary};
  color: ${p => p.theme.colors.background.paper};
  border: none;
  transition: opacity 0.18s;
  &:hover { opacity: 0.85; }
`;

export const StmtList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StmtItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: ${p => p.theme.colors.background.main};
  border-radius: 12px;
  border: 1px solid ${p => p.theme.colors.background.selected};
  gap: 12px;
`;

export const StmtItemInfo = styled.div``;
export const StmtItemTitle = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: ${p => p.theme.colors.text.primary};
  margin: 0;
`;
export const StmtItemSub = styled.p`
  font-size: 11px;
  color: ${p => p.theme.colors.text.disabled};
  margin: 2px 0 0;
`;

export const StmtDlBtn2 = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background: none;
  border: 1.5px solid ${p => p.theme.colors.border.main};
  color: ${p => p.theme.colors.primary.light};
  cursor: pointer;
  transition: all 0.15s;
  &:hover { background: ${p => p.theme.colors.background.selected}; border-color: ${p => p.theme.colors.border.hover}; }
`;

/* -- Account Details tab -- */

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
`;

export const DetailCard = styled.div`
  background: ${p => p.theme.colors.background.main};
  border: 1px solid ${p => p.theme.colors.background.selected};
  border-radius: 12px;
  padding: 16px 18px;
`;

export const DetailLabel = styled.p`
  font-size: 11px;
  font-weight: 700;
  color: ${p => p.theme.colors.text.disabled};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 6px;
`;

export const DetailValue = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: ${p => p.theme.colors.text.primary};
  margin: 0;
  word-break: break-all;
`;

// ─────────────────────────────────────────────
// DATA
// ─────────────────────────────────────────────

